import {useSignOut} from 'react-firebase-hooks/auth';

import {firebase} from '@/library';

export default function useFirebaseAuthState() {
	return useSignOut(firebase.authInstance);
}
